import { createClient } from '@supabase/supabase-js'

// Замените на свои значения из Supabase → Settings → API
const supabaseUrl = 'https://nzypaksmxerwfwvigvou.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im56eXBha3NteGVyd2Z3dmlndm91Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY1OTAzMDcsImV4cCI6MjA2MjE2NjMwN30.wu3oaSt2F1VdqLK6kpYXTv-9Zr-jXlya2TLfOvIGt3E'

const supabase = createClient(supabaseUrl, supabaseKey)
export default supabase

